import React, {useEffect, useState} from "react";
import { IProfile } from '../../../interface/IProfile.ts';
import { useProfileApi } from '../../../features/auth/hooks/use-profile-api.ts'
import { ApiResponseType } from "../../../features/api/types.ts";
import { useListsApi } from "../../../features/auth/hooks/use-lists-api.ts";
import { IOption } from "../../../interface/IOption.ts";
import Checkboxes from "../../Form/Checkboxes.tsx";
import Form from "../../Form/Form.tsx";
import ApiCheck from '../../Structure/ApiCheck.tsx';

const TabLanguages = ({
    profile,
    setProfile
}:{
    profile:IProfile
    setProfile: Function
}) => {
    const [languageList, setLanguageList] = useState<Array<any>>([]);
    const [languagesLoading, setLanguagesLoading] = useState<boolean>(true);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState<string>('');
    const { postProfile } = useProfileApi();
    const [errors, setErrors] = useState<any>({});
    const { getList } = useListsApi();
    const [apiErrors, setApiErrors] = useState<any>();

    const [unSavedChanges, setUnSavedChanges] = useState(false);

    const [formData, setFormData] = useState<IProfile>({
        coaching_languages: profile.coaching_languages ?? [],
    });

    const handleChange = (event, name = '', value = null) => {
        setFormData({ ...formData, [name ? name : event.target.name]: value ? value : event.target.value });
        !unSavedChanges && setUnSavedChanges(true);
    };

    const expectedAmountLanguages:number = 7;

    const handleSubmit = (event) => {
        event.preventDefault();
        setUnSavedChanges(false);
        setIsLoading(true);

        let postedData:{coaching_languages:Array<string>} = {
            coaching_languages: [],
        };
        let languageIds = formData.coaching_languages!.map(el => {
            return el.value;
        });
        postedData.coaching_languages = languageIds;

        setErrors({});
        postProfile(postedData).then(res => {
            setIsLoading(false);
            if (res.type === ApiResponseType.OK) {
                if (res.payload.success)  {
                    setResponseMessage('Erfolgreich gespeichert');
                    setResponseMessageClass('success');
                    setProfile({...profile, ...postedData});
                    setTimeout(() => {
                        setResponseMessage('');
                    }, 5000);
                }
            } else {
                let errors = res.payload.errors!;
                if (!errors.general_error) {
                    setResponseMessage('Fehler. Bitte korrigieren Sie den Fehler und versuchen Sie es erneut.');
                    setResponseMessageClass('error');
                }
                setErrors(errors);
            }
        })
    }

    useEffect(() => {
        let formDataClone = structuredClone(formData);
        getList('coaching_languages').then(res => {
            let optionList:Array<IOption> = [];
            if (res) {
                res.forEach((item:any) => {
                    optionList.push({
                        value: item.id,
                        label: item.label
                    });
                });
                setLanguageList(optionList);
                let languagesFromOptions:Array<IOption> = [];
                languagesFromOptions = optionList.filter(singleLanguageOption => {
                    return profile.coaching_languages?.includes(singleLanguageOption.value);
                });
                formDataClone = { ...formDataClone, coaching_languages: languagesFromOptions }
                setFormData(formDataClone);
                setLanguagesLoading(false);
            }
        }).catch(() => {
            setApiErrors({
                errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
            });
            setLanguagesLoading(false);
        });
    }, []);

    return (
        <div className="single-tab-item">
            <Form
                unSavedChanges={unSavedChanges}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                responseMessage={responseMessage}
                responseMessageClass={responseMessageClass}
                generalErrors={ errors.general_error ? errors.general_error : null}
                intro="Bitte markieren Sie die Sprachen, in denen Sie beraten. Die Auswahl ist auch Basis für die Suche auf der FPSB-Webseite."
            >
                { languagesLoading ? (
                    <div className="form-group checkboxes no-label">
                        <div className="checkbox-inputs-wrapper">
                            {[...Array(expectedAmountLanguages)].map((k,i) =>
                                <div className="single-checkbox" key={'cl_' + i}>
                                    <input type="checkbox" disabled />
                                    <label><div className="checkbox-loader"></div></label>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors ? apiErrors : null}>
                        <Checkboxes
                            name='coaching_languages'
                            onChange={(item:IOption, wasChecked:boolean) => {
                                if (wasChecked) {
                                    let x = formData.coaching_languages.filter(el => {
                                        return el.value !== item.value
                                    });
                                    handleChange(null, 'coaching_languages', x);
                                } else {
                                    let x = structuredClone(formData.coaching_languages);
                                    x.push(item);
                                    handleChange(null, 'coaching_languages', x);
                                }
                            }}
                            value={formData?.coaching_languages}
                            options={languageList}
                            error={errors['coaching_languages']}
                        />
                    </ApiCheck>
                ) }
            </Form>
        </div>
    )
}

export default TabLanguages;
